<template>
	<div>
		<div class="index">
			<div class="m view">
				<div class="head">
					<img src="../../assets/images/index/icon_order.svg" style="width:100px;height:100px;" />
					<div>Status Success</div>
				</div>
				<div class="body flex_between_x">
					<ul class="left_ul">
						<li>
							<div class="label">Timestamp:
							</div>
							<div class="font">{{List.created_at}}</div>
						</li>
						<li>
							<div class="label">Sender:

							</div>
							<div class="font" style="cursor:pointer;">
								{{List.s_contract_address}}
							</div>
						</li>
						<li>
							<div class="label">Receiver:

							</div>
							<div class="font" style="cursor:pointer;">
								{{List.r_contract_address}}
							</div>
						</li>
						<li>
							<div class="label">TX ID:
							</div>
							<div class="font">{{List.order_no}}</div>
						</li>
					</ul>
					<!-- <div class="right_img" style="cursor:pointer;" @click="nav_shop()">
						<el-image style="width:100%; height:300px" :src="List.cover" fit="cover">
							<div slot="error" class="image-slot flex_all" style="height:100%;">
								<i class="el-icon-loading" style="font-size:20px;"></i>
							</div>
						</el-image>
						<div class="font">
							<p class="title">{{List.title}}</p>
							<div class="flex_between_x">
								<span>
									versions:{{List.serial}}/{{List.num}}
								</span>
								<div class="flex_start">
									<img src="../../assets/images/index/aixin.png"
										style="width:20px;height:20px;border-radius:50%;margin-right:5px;">
									{{List.fond_count}}
								</div>
							</div>
						</div>
						<div class="flex_start " style="padding:15px 10px 10px 10px;">
							<span>original</span>
							<div class="flex_start" style="margin-left:20px;">
								<el-image style="width: 30px; height: 30px ;border-radius:50%;margin-right:10px;"
									:src="List.o_avatar" fit="cover">
									<div slot="error" class="image-slot flex_all" style="height:100%;">
										<i class="el-icon-loading" style="font-size:20px;"></i>
									</div>
								</el-image>
								<span>{{List.o_nickname}}</span>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	function formatDate(value) {
		if (typeof(value) == 'undefined') {
			return ''
		} else {
			let date = new Date(parseInt(value))
			let y = date.getFullYear()
			let MM = date.getMonth() + 1
			MM = MM < 10 ? ('0' + MM) : MM
			let d = date.getDate()
			d = d < 10 ? ('0' + d) : d
			let h = date.getHours()
			h = h < 10 ? ('0' + h) : h
			let m = date.getMinutes()
			m = m < 10 ? ('0' + m) : m
			let s = date.getSeconds()
			s = s < 10 ? ('0' + s) : s
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
		}
	}
	export default {
		name: 'index',
		data() {
			return {
				List: []
			}
		},
		mounted() {
			this.get(this.$route.query.tx)
		},
		methods: {
			async get(order_no) {
				let res = await this.$api.orderdetails({
					order_no: order_no
				})
				if (res.code == 200) {
					console.log(res.data[0])
					this.List = res.data[0]
					this.List.created_at = formatDate(this.List.created_at * 1000)
				}
			},
			nav_shop() {
				this.$router.push({
					name: 'shop',
					query: {
						tid: this.List.tid
					}
				})
			},
			nav_s_address() {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: this.List.r_contract_address
					}
				})
			},
			nav_r_address() {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: this.List.r_contract_address
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	.index {
		width: 100%;
		margin-top: 70px;
		padding-bottom: 100px;

		.view {
			text-align: center;
			padding: 100px 0px;

			.head {
				div {
					font-size: 24px;
					margin-top: 20px;
				}
			}

			.body {
				width: 100%;
				box-shadow: 0 1px 23px 0 #b9b9b9;
				margin-top: 40px;
				padding: 40px 80px;
				align-items: center;
				border-radius: 5px;

				.left_ul {
					display: inline-block;

					li {
						display: flex;
						justify-content: flex-start;
						height: 50px;
						line-height: 50px;

						.label {
							font-size: 20px;
							width: 150px;
							text-align: left;
						}

						.font {
							color: #74777e;
							font-size: 20px;
						}
					}
				}

				.right_img {
					width: 220px;
					border: 1px solid #000000;
					border-radius: 10px;
					overflow: hidden;

					.font {
						border-bottom: 1px solid #CCCCCC;
						padding: 10px;
						text-align: left;

						.title {
							font-size: 14px;
							font-weight: 550;
							margin-bottom: 10px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 720px) {
		.body {
			width: 90% !important;
			padding: 20px !important;
			display: inline-block;
			overflow: hidden;

			.left_ul {
				li {
					.label {
						font-size: 14px !important;
						width: 100px !important;
					}

					.font {
						font-size: 14px !important;
						width: 200px !important;
						text-align: left;
						display: inline-block !important;
						// width:400rpx; 
						/*超出部分隐藏*/
						white-space: nowrap !important;
						overflow: hidden !important;
						/*不换行*/
						text-overflow: ellipsis !important;
						/*超出部分文字以...显示*/
					}

				}

			}

			.right_img {
				width: 100% !important;
			}
		}


	}
</style>
